
export default function MapSection() {
  return (
    <section className="py-16 sm:py-20 bg-gray-50">
      {/* Map section removed */}
    </section>
  );
}
